var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto"},[_c('news-card-company',{attrs:{"data":_vm.company_data,"queries":_vm.matched_queries}}),_c('news-card-type',{attrs:{"data":_vm.type_data}}),_c('news-card-contact',{attrs:{"data":_vm.contact_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }